/* eslint-disable camelcase */

import _ from 'underscore';

function getImportEntityOptionValue(options, type, value) {
  // when editing old scheduled import, ImportNewOptions property is null
  if (options[type]) {
    const newOptions = _.map(options[type].split(','), string => (
      string.trim()
    ));

    return _.contains(newOptions, value);
  }
  // Do not set this as true by default
  if (value === 'ImportNewCampaignsAndMarkAsPaused') {
    return false;
  }
  return true;
}

function getNewItemValue(options, value) {
  return getImportEntityOptionValue(options, 'ImportNewOptions', value);
}

function getExistingItemValue(options, value) {
  return getImportEntityOptionValue(options.UpdateEntityPreferences, 'ImportUpdateOptions', value);
}

export function parseEditScheduledImportOptions({
  options,
  isPageFeedEnabled,
  isDeviceTargetOptimizationEnabled = false,
  isAdScheduleUseSearcherTimezoneEnabled = false,
  isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled = false,
  isGoogleImageExtensionImportOptionEnabled = false,
  isAudienceTargetForFBImportOptionEnabled = false,
  isGoogleLogoExtensionImportOptionEnabled = false,
  isGoogleUpdateAdUrlsImportOptionEnabled = false,
  isGoogleUpdateSitelinkUrlsImportOptionEnabled = false,
  isGoogleAccountNegativeKeywordsImportOptionEnabled = false,
  isGoogleAdCustomizerAttributesImportOptionEnabled = false,
  isGoogleConversionGoalsImportOptionEnabled = false,
  isBrandSuitabilityImportOptionEnabled = false,
}) {
  let mappedOptions = {
    ImportAccountUrlOptions: _.size(options.UserSetProperties2) > 0,
    // ImportNewItems
    ImportNewEntities: options.ImportNewEntities,
    ImportNewOption_ImportNewCampaignsAndMarkAsPaused: getNewItemValue(options, 'ImportNewCampaignsAndMarkAsPaused'),
    ImportNewOption_ImportNewCampaignsAndChildEntities: getNewItemValue(options, 'ImportNewCampaignsAndChildEntities'),
    ImportNewOption_ImportNewAdGroupsAndChildEntitiesForExistingCampaigns: getNewItemValue(options, 'ImportNewAdGroupsAndChildEntitiesForExistingCampaigns'),
    ImportNewOption_ImportNewAdsForExistingAdGroups: getNewItemValue(options, 'ImportNewAdsForExistingAdGroups'),
    ImportNewOption_ImportNewKeywordsForExistingAdGroups: getNewItemValue(options, 'ImportNewKeywordsForExistingAdGroups'),
    ImportNewOption_ImportNewNegativeKeywordsForExistingParents: getNewItemValue(options, 'ImportNewNegativeKeywordsForExistingParents'),
    ImportNewOption_ImportNewNegativeKeywordList: getNewItemValue(options, 'ImportNewNegativeKeywordList'),
    ImportNewOption_ImportNewLocationTargets: getNewItemValue(options, 'ImportNewLocationTargets'),
    ImportNewOption_ImportNewAppAdExtensions: getNewItemValue(options, 'ImportNewAppAdExtensions'),
    // ExistingItems
    UpdateEntityPreferences: options.UpdateEntityPreferences.ImportUpdatedEntities,
    ImportUpdateEntityPreference_UpdateCampaignBudget: getExistingItemValue(options, 'UpdateCampaignBudget'),
    ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids: getExistingItemValue(options, 'UpdateAdGroupAndKeywordBids'),
    ImportUpdateEntityPreference_UpdateExistingNegativeKeywordList: getExistingItemValue(options, 'UpdateExistingNegativeKeywordList'),
    ImportUpdateEntityPreference_UpdateNegativeSites: getExistingItemValue(options, 'UpdateNegativeSites'),
    ImportUpdateEntityPreference_UpdateKeywordDestinationUrl: getExistingItemValue(options, 'UpdateKeywordDestinationUrl'),
    ImportUpdateEntityPreference_UpdateTrackingTemplateAndCustomParams: getExistingItemValue(options, 'UpdateTrackingTemplateAndCustomParams'),
    ImportUpdateEntityPreference_UpdateLocationTargets: getExistingItemValue(options, 'UpdateLocationTargets'),
    ImportUpdateEntityPreference_UpdateAdExtensions: getExistingItemValue(options, 'UpdateAdExtensions'),
    ImportUpdateEntityPreference_UpdateStatusForExistingCampaigns: getExistingItemValue(options, 'UpdateStatusForExistingCampaigns'),
    ImportUpdateEntityPreference_UpdateStatusForExistingAdGroups: getExistingItemValue(options, 'UpdateStatusForExistingAdGroups'),
    ImportUpdateEntityPreference_UpdateStatusForExistingAds: getExistingItemValue(options, 'UpdateStatusForExistingAds'),
    ImportUpdateEntityPreference_UpdateStatusForExistingKeywords: getExistingItemValue(options, 'UpdateStatusForExistingKeywords'),
    ImportUpdateEntityPreference_UpdateLanguageForExistingAdGroups: getExistingItemValue(options, 'UpdateLanguageForExistingAdGroups'),
    // DeletedItems
    ImportDeletedEntities: options.ImportDeletedEntities,
    // BidsAndBudgets
    DefaultBidsBelowMinToAdCenterMinBid: options.DefaultBidsBelowMinToAdCenterMinBid,
    DefaultCampaignBudgetBelowMinToAdCenterMinBudget:
      options.DefaultCampaignBudgetBelowMinToAdCenterMinBudget,
    // OtherItems
    ImportAppendDestUrlPreference_UseAppendString: options.AppendDestUrlPreference.UseAppendString,
    ImportAppendDestUrlPreference_AppendStringForDestinationUrl:
      options.AppendDestUrlPreference.AppendStringForDestinationUrl,
    ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString:
      options.SearcAndReplaceDestUrlPreference.UseSearchAndReplaceString,
    ImportSearchAndReplaceDestUrlPreference_SearchStringForDestinationUrl:
      options.SearcAndReplaceDestUrlPreference.SearchStringForDestinationUrl,
    ImportSearchAndReplaceDestUrlPreference_ReplaceStringForDestinationUrl:
      options.SearcAndReplaceDestUrlPreference.ReplaceStringForDestinationUrl,
    AppendPreferencesForTrackingTemplate_UseAppendString:
      options.AppendTrackingTemplatePreference.UseAppendString,
    AppendPreferencesForTrackingTemplate_AppendStringForTrackingTemplate:
      options.AppendTrackingTemplatePreference.AppendStringForTrackingTemplate,
    SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString:
      options.SearchAndReplaceTrackingTemplatePreference.UseSearchAndReplaceString,
    SearchAndReplacePreferencesForTrackingTemplate_SearchStringForTrackingTemplate:
      options.SearchAndReplaceTrackingTemplatePreference.SearchStringForTrackingTemplate,
    SearchAndReplacePreferencesForTrackingTemplate_ReplaceStringForTrackingTemplate:
      options.SearchAndReplaceTrackingTemplatePreference.ReplaceStringForTrackingTemplate,
    // Import Options V2 options:
    // behavior for option is opposite of the enum name (if checked, don't pass back this value)
    ImportUpdateEntityPreference_UpdateNameForExistingCampaigns: !getExistingItemValue(options, 'UpdateNameForExistingCampaigns'),
    ImportNewOption_ImportNewActiveEntitiesOnly: !getNewItemValue(options, 'ImportNewActiveEntitiesOnly'),
    StoreIdForImportedProductAdExtensionsFlag: !!options.StoreIdForImportedProductAdExtensions,
    StoreIdForImportedProductAdExtensions: options.StoreIdForImportedProductAdExtensions,
    ImportNewOption_ImportNewDayTimeTargets: getNewItemValue(options, 'ImportNewDayTimeTargets'),
    ImportNewOption_ImportNewDeviceTargets: getNewItemValue(options, 'ImportNewDeviceTargets'),
    ImportNewOption_ImportNewDemographicTargets: getNewItemValue(options, 'ImportNewDemographicTargets'),
    ImportNewOption_ImportNewCallAdExtensions: getNewItemValue(options, 'ImportNewCallAdExtensions'),
    ImportNewOption_ImportNewCalloutAdExtensions: getNewItemValue(options, 'ImportNewCalloutAdExtensions'),
    ImportNewOption_ImportNewLocationAdExtensions: getNewItemValue(options, 'ImportNewLocationAdExtensions'),
    ImportNewOption_ImportNewPriceAdExtensions: getNewItemValue(options, 'ImportNewPriceAdExtensions'),
    ImportNewOption_ImportNewPromotionAdExtensions: getNewItemValue(options, 'ImportNewPromotionAdExtensions'),
    ImportNewOption_ImportNewReviewAdExtensions: getNewItemValue(options, 'ImportNewReviewAdExtensions'),
    ImportNewOption_ImportNewSitelinkAdExtensions: getNewItemValue(options, 'ImportNewSitelinkAdExtensions'),
    ImportNewOption_ImportNewStructuredSnippetAdExtensions: getNewItemValue(options, 'ImportNewStructuredSnippetAdExtensions'),
    ImportUpdateEntityPreference_UpdateDayTimeTargets: getExistingItemValue(options, 'UpdateDayTimeTargets'),
    ImportUpdateEntityPreference_UpdateDeviceTargets: getExistingItemValue(options, 'UpdateDeviceTargets'),
    ImportUpdateEntityPreference_UpdateDemographicTargets: getExistingItemValue(options, 'UpdateDemographicTargets'),
    ImportUpdateEntityPreference_UpdateAppAdExtensions: getExistingItemValue(options, 'UpdateAppAdExtensions'),
    ImportUpdateEntityPreference_UpdateCallAdExtensions: getExistingItemValue(options, 'UpdateCallAdExtensions'),
    ImportUpdateEntityPreference_UpdateCalloutAdExtensions: getExistingItemValue(options, 'UpdateCalloutAdExtensions'),
    ImportUpdateEntityPreference_UpdateLocationAdExtensions: getExistingItemValue(options, 'UpdateLocationAdExtensions'),
    ImportUpdateEntityPreference_UpdatePriceAdExtensions: getExistingItemValue(options, 'UpdatePriceAdExtensions'),
    ImportUpdateEntityPreference_UpdatePromotionAdExtensions: getExistingItemValue(options, 'UpdatePromotionAdExtensions'),
    ImportUpdateEntityPreference_UpdateReviewAdExtensions: getExistingItemValue(options, 'UpdateReviewAdExtensions'),
    ImportUpdateEntityPreference_UpdateSitelinkAdExtensions: getExistingItemValue(options, 'UpdateSitelinkAdExtensions'),
    ImportUpdateEntityPreference_UpdateStructuredSnippetAdExtensions: getExistingItemValue(options, 'UpdateStructuredSnippetAdExtensions'),
    ImportPrefixAndSuffixForStringProperty_EnablePrefixAndSuffix:
      !!options.PrefixAndSuffixForCampaignNames &&
      options.PrefixAndSuffixForCampaignNames.EnablePrefixAndSuffix,
    ImportPrefixAndSuffixForStringProperty_SuffixString:
      options.PrefixAndSuffixForCampaignNames ?
        options.PrefixAndSuffixForCampaignNames.SuffixString : '',
    ImportSearchAndReplaceForStringProperty_EnableSearchAndReplace:
      !!options.SearchAndReplaceForCampaignNames &&
      options.SearchAndReplaceForCampaignNames.EnableSearchAndReplace,
    ImportSearchAndReplaceForStringProperty_SearchString:
      options.SearchAndReplaceForCampaignNames ?
        options.SearchAndReplaceForCampaignNames.SearchString : '',
    ImportSearchAndReplaceForStringProperty_ReplaceString:
      options.SearchAndReplaceForCampaignNames ?
        options.SearchAndReplaceForCampaignNames.ReplaceString : '',

    PauseAdGroupIfNoLocationSupported: options.PauseAdGroupIfNoLocationSupported,
    EnableAutoCurrencyConversion: options.EnableAutoCurrencyConversion,
  };

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewKeywordUrls: getNewItemValue(options, 'ImportNewKeywordUrls'),
    ImportNewOption_ImportNewTrackingTemplateAndCustomParams: getNewItemValue(options, 'ImportNewTrackingTemplateAndCustomParams'),
    ImportNewOption_ImportNewNegativeSites: getNewItemValue(options, 'ImportNewNegativeSites'),
    ImportUpdateEntityPreference_UpdateAdGroupNetworkSetting: getExistingItemValue(options, 'UpdateAdGroupNetworkSetting'),
    AdjustmentForBids_EnableAdjustment:
      (options.AdjustmentForBids && !!options.AdjustmentForBids.EnableAdjustment) || false,
    AdjustmentForBids_AdjustmentValue:
      (options.AdjustmentForBids &&
        options.AdjustmentForBids.AdjustmentValue) || 0,
    AdjustmentForCampaignBudgets_EnableAdjustment:
      (options.AdjustmentForCampaignBudgets
        && !!options.AdjustmentForCampaignBudgets.EnableAdjustment) || false,
    AdjustmentForCampaignBudgets_AdjustmentValue:
      (options.AdjustmentForCampaignBudgets
          && options.AdjustmentForCampaignBudgets.AdjustmentValue) || 0,
    PauseParentIfNoLocationSupported: options.PauseParentIfNoLocationSupported,
    EnableParentLocationMapping: options.EnableParentLocationMapping === false,
  });

  mappedOptions = _.extend(mappedOptions, {
    RaiseLowBidsToMinServingBidsForBsc: options.RaiseLowBidsToMinServingBidsForBsc,
  });

  if (isDeviceTargetOptimizationEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      AutoDeviceBidOptimization: options.AutoDeviceBidOptimization,
    });
  }

  if (isAdScheduleUseSearcherTimezoneEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      AdScheduleUseSeacherTimezone: options.AdScheduleUseSeacherTimezone,
    });
  }

  if (isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      PauseAIMAdGroupIfAllAudienceCriterionNotImported:
        options.PauseAIMAdGroupIfAllAudienceCriterionNotImported,
    });
  }

  if (isGoogleImageExtensionImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewImageAdExtensions: getNewItemValue(options, 'ImportNewImageAdExtensions'),
      ImportUpdateEntityPreference_UpdateImageAdExtensions: getExistingItemValue(options, 'UpdateImageAdExtensions'),
    });
  }

  if (isGoogleLogoExtensionImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewLogoAdExtensions: getNewItemValue(options, 'ImportNewLogoAdExtensions'),
      ImportUpdateEntityPreference_UpdateLogoAdExtensions: getExistingItemValue(options, 'UpdateLogoAdExtensions'),
    });
  }

  if (isGoogleConversionGoalsImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewConversionGoals: getNewItemValue(options, 'ImportNewConversionGoals'),
      ImportUpdateEntityPreference_UpdateConversionGoals: getExistingItemValue(options, 'UpdateConversionGoals'),
    });
  }

  if (isGoogleUpdateAdUrlsImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportUpdateEntityPreference_UpdateAdUrls: getExistingItemValue(options, 'UpdateAdUrls'),
    });
  }

  if (isGoogleUpdateSitelinkUrlsImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportUpdateEntityPreference_UpdateSitelinkUrls: getExistingItemValue(options, 'UpdateSitelinkUrls'),
    });
  }

  if (isGoogleAccountNegativeKeywordsImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewAccountNegativeKeywords: getNewItemValue(options, 'ImportNewAccountNegativeKeywords'),
    });
  }

  if (isGoogleAdCustomizerAttributesImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportUpdateEntityPreference_UpdateAdCustomizerAttributes: getExistingItemValue(options, 'UpdateAdCustomizerAttributes'),
    });
  }

  if (isBrandSuitabilityImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewBrandSuitability: getExistingItemValue(options, 'ImportNewBrandSuitability'),
      ImportUpdateEntityPreference_UpdateBrandSuitability: getExistingItemValue(options, 'UpdateBrandSuitability'),
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    ImportSearchAndDsaMixedCampaignAsSearchCampaign:
      options.ImportSearchAndDsaMixedCampaignAsSearchCampaign,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewAudienceTargets: getNewItemValue(options, 'ImportNewAudienceTargets'),
    ImportUpdateEntityPreference_UpdateAudienceTargets: getExistingItemValue(options, 'UpdateAudienceTargets'),
  });

  if (isAudienceTargetForFBImportOptionEnabled) {
    // NoAudienceTargetForFBImportOptionTest
    mappedOptions = _.extend(mappedOptions, {
      NoAudienceTargetForFBImportOption: !getNewItemValue(options, 'ImportNewAudienceTargets') && !getExistingItemValue(options, 'UpdateAudienceTargets'),
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    ImportUET: mappedOptions.ImportNewOption_ImportNewAudienceTargets
      && !!options.AssociatedUETTagId,
    AssociatedUETTagId: options.AssociatedUETTagId || '',
  });

  mappedOptions = _.extend(mappedOptions, {
    SearchAndReplaceForCustomParameters_EnableSearchAndReplace:
        options.SearchAndReplaceForCustomParameters.EnableSearchAndReplace,
    SearchAndReplaceForCustomParameters_SearchString:
        options.SearchAndReplaceForCustomParameters.SearchString,
    SearchAndReplaceForCustomParameters_ReplaceString:
        options.SearchAndReplaceForCustomParameters.ReplaceString,
  });

  mappedOptions = _.extend(mappedOptions, {
    SearchAndReplaceForFinalURLSuffix_EnableSearchAndReplace:
        options.SearchAndReplaceForFinalURLSuffix.EnableSearchAndReplace,
    SearchAndReplaceForFinalURLSuffix_SearchString:
        options.SearchAndReplaceForFinalURLSuffix.SearchString,
    SearchAndReplaceForFinalURLSuffix_ReplaceString:
        options.SearchAndReplaceForFinalURLSuffix.ReplaceString,
  });

  if (isPageFeedEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewPageFeeds: getNewItemValue(options, 'ImportNewPageFeeds'),
      ImportUpdateEntityPreference_UpdatePageFeeds: getExistingItemValue(options, 'UpdatePageFeeds'),
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewAdCustomizerFeeds: getNewItemValue(options, 'ImportNewAdCustomizerFeeds'),
    ImportUpdateEntityPreference_UpdateAdCustomizerFeeds: getExistingItemValue(options, 'UpdateAdCustomizerFeeds'),
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportAllAdUnderAnAdGroup: getNewItemValue(options, 'ImportAllAdUnderAnAdGroup'),
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewLabelsAndAssociations:
      (options.ImportNewLabelsAndAssociations != null)
        ? options.ImportNewLabelsAndAssociations
        : options.ImportNewEntities,
    UpdateLabelsAndAssociations:
      (options.UpdateLabelsAndAssociations != null)
        ? options.UpdateLabelsAndAssociations
        : options.UpdateEntityPreferences.ImportUpdatedEntities,
  });
  mappedOptions = _.extend(mappedOptions, {
    ImportNewCustomFiltersForShoppingCampaigns:
      (options.ImportNewCustomFiltersForShoppingCampaigns != null)
        ? options.ImportNewCustomFiltersForShoppingCampaigns
        : options.ImportNewEntities,
    UpdateCustomFiltersForShoppingCampaigns:
      (options.UpdateCustomFiltersForShoppingCampaigns != null)
        ? options.UpdateCustomFiltersForShoppingCampaigns
        : options.UpdateEntityPreferences.ImportUpdatedEntities,
  });
  mappedOptions = _.extend(mappedOptions, {
    ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBidStrategies:
    !!options.UpdateBiddingStrategies,
  });

  return mappedOptions;
}
